import React, { useEffect, useState } from "react"
import API from "../../api"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import useInfiniteScroll from "../../hooks/useInfiniteScroll"
import { useLanguage } from "@languages/index"
import Paginator from "components/paginator"
import BRAND_PAYMENTS from "constants/brandPayments"

const PaymentsIndex = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.payments }
  const [histories, setHistories] = useState([])
  const [historiesCnt, setHistoriesCnt] = useState(0)

  const [schedule, setSchedule] = useState(undefined)
  const [isFetchFinished, setIsFetchFinished] = useState(false)
  const [isContentEnded, setIsContentEnded] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [paginator, setPaginator] = useState(undefined)

  const [isFetching, setIsFetching] = useInfiniteScroll(() => {
    // if (histories.length) {
    //   fetchPaymentHistories()
    // }
  })

  // useEffect(() => {
  //   if (!histories.length && !isContentEnded) {
  //     fetchPaymentHistories(true)
  //   }
  // }, [histories])

  useEffect(() => {
    fetchPaymentHistories({ refresh: true })
  }, [isFetching])

  const fetchPaymentHistories = (config?) => {
    let targetPage = config?.page ? config.page : currentPage
    if (config?.refresh) targetPage = 1

    API.Payment.index({
      ...{
        brandToken: props.auth.token,
        page: targetPage,
      },
    })
      .then((response) => {
        const fetchedHistories = response.data.histories.data
        setHistories(fetchedHistories)
        setHistoriesCnt(response.data.count)
        setSchedule(response.data.schedule)

        setCurrentPage(targetPage)
        setIsFetchFinished(true)

        if (response.data.histories.currentPage == response.data.histories.lastPage) {
          setIsContentEnded(true)
        }

        setPaginator(response.data.histories)

        setIsFetching(false)
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
  }

  const renderPageTitle = () => {
    return (
      <div className="flex flex-row justify-between mb-2 lg:mb-9">
        <span className="font-bold text-xl tracking-tighter">{languageTexts.payment_history2}</span>
      </div>
    )
  }

  const renderHistories = () => {
    const renderMetaData = (metaDataJsonText: any) => {
      try {
        const metaData = JSON.parse(metaDataJsonText)

        const texts = []
        if (metaData?.tags?.is_additional_seeding)
          texts.push('추가 선정으로 인한 원고료')
        if (metaData?.tags?.is_commission_increased)
          texts.push('원고료 상향으로 인한 추가 비용')

        return texts.length > 0 ? (
          <div className="text-[12px] text-[#FF0000]">
            {`(${texts.join(' + ')})`}
          </div>
        ) : null

      } catch (e) {
        return null
      }
    }
    
    if (isFetchFinished && histories.length == 0) {
      return (
        <div className="py-10 flex flex-col justify-center w-full items-center">
          <div className="mx-5 flex">
            <span className="prose prose-xl text-slate-500">{languageTexts.index_text_1}</span>
          </div>
        </div>
      )
    }

    return (
      <div className="flex flex-col py-10">
        <div className="flex flex-row py-2 bg-black justify-around font-bold text-white">
          <span className="flex-1 justify-center text-center text-[13px] font-bold">{languageTexts.index_text_2}</span>
          <span className="flex-1 justify-center text-center text-[13px] font-bold">{languageTexts.index_text_3}</span>
          {/* <span className="flex-1 justify-center text-center text-[13px] font-bold">
            상품 상태
          </span> */}
          <span className="flex-1 justify-center text-center text-[13px] font-bold">{languageTexts.index_text_4}</span>
          <span className="flex-1 justify-center text-center text-[13px] font-bold">{languageTexts.index_text_5}</span>
        </div>

        {histories.map((history, idx) => {
          let price = history.price;
          let productDesc = history.productDesc;
          let hasVatTag = false;

          if (props.brand.isCategoryBeauty) {
            switch (history.productType) {
              case BRAND_PAYMENTS.PRODUCT_TYPE_CD.PRODUCT_SEEDING_COMMISSION:
                if (history.campaignPayments != null && history.campaignPayments.length > 0) {
                  price = history.campaignPayments.reduce((acc, curr) => {
                    return acc + curr.priceTotal;
                  }, 0);
                }
                productDesc = languageTexts.index_text_7;
                hasVatTag = true
                break;
              case BRAND_PAYMENTS.PRODUCT_TYPE_CD.PRODUCT_SEEDING_INSPECTION_FEE:
                if (history.campaignPayments != null && history.campaignPayments.length > 0) {
                  price = history.campaignPayments.reduce((acc, curr) => {
                    return acc + curr.priceTotal;
                  }, 0);
                }
                productDesc = languageTexts.index_text_9;
                hasVatTag = true
                break;
              case BRAND_PAYMENTS.PRODUCT_TYPE_CD.PRODUCT_SEEDING:
              case BRAND_PAYMENTS.PRODUCT_TYPE_CD.PRODUCT_SEEDING_BEAUTY_SINGLE:
                if (history.campaignPayments != null && history.campaignPayments.length > 0) {
                  price = history.campaignPayments.reduce((acc, curr) => {
                    return acc + curr.priceTotal;
                  }, 0);
                }
                productDesc = languageTexts.index_text_6;
                hasVatTag = true
                break;
              case BRAND_PAYMENTS.PRODUCT_TYPE_CD.PRODUCT_SEEDING_COMMISSION_INCREASE:
                if (history.campaignPayments != null && history.campaignPayments.length > 0) {
                  price = history.campaignPayments.reduce((acc, curr) => {
                    return acc + curr.priceTotal;
                  }, 0);
                }
                price = price * 1.1
                productDesc = languageTexts.index_text_10;
                hasVatTag = true
                break;
              default:
                break;
            }
          }

          if (price === 0) {
            return null
          }

          return (
            <div
              key={history.id}
              className="flex py-4 flex-row justify-around border-b border-grey-200"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
            >
              <span className="flex-1 justify-center text-center">{history.createdDate}</span>
              <div className="flex-1 flex flex-col items-start">
                <div className="flex-1 justify-center text-center">{productDesc}</div>
                {history?.metaData != null
                  ? renderMetaData(history.metaData)
                    : null}
              </div>
                
              {/* <span className="flex-1 justify-center text-center">
                {history.productStatusDesc}
              </span> */}
              <span className="flex-1 justify-center text-center">{history.paymentStatusDesc}</span>
              <div className="flex-1 flex flex-col text-center">
                <span className=" justify-center text-center">
                  {languageTexts._price(price.toLocaleString(), props.settings.currencyText)}{" "}
                  {/* {!history.postingId ? "(예정)" : null} */}
                </span>
                {hasVatTag && (
                  <span className="text-[#888888] text-[10px] justify-center text-center">{languageTexts.index_text_8}</span>
                )}
              </div>

            </div>
          )
        })}

        {paginator != null && (
          <Paginator
            currentPage={paginator.currentPage}
            lastPage={paginator.lastPage}
            onPageChange={(page) => {
              console.log('[page]', page)
              fetchPaymentHistories({ page: page })
            }}
          />
        )}
      </div>
    )
  }

  return (
    <>
      <div className="px-5 py-6 xl:px-10 pb-10 mx-auto w-full max-w-[800px]">
        {renderPageTitle()}
        {renderHistories()}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(PaymentsIndex)
